export enum MemberStatus {
    ACTIVE_MEMBER = 'ACTIVE_MEMBER',
    PASSIVE_MEMBER = 'PASSIVE_MEMBER'
}

export enum ConsentType {
    PRIVACY_AGREEMENT = 'PRIVACY_AGREEMENT',
    MEDIA_CONSENT = 'MEDIA_CONSENT'
}

export enum ConsentAction {
    GRANTED = 'GRANTED',
    REVOKED = 'REVOKED'
}

export interface MemberConsentLog {
    id: string;
    organizationId: string;
    memberId: string;
    consentType: ConsentType;
    action: ConsentAction;
    timestamp: string;
    createdAt: string;
    createdBy: string;
}

export interface PendingNDAMember {
    id: string;
    memberNo: number;
    firstName: string;
    lastName: string;
    membershipStart: string;
    daysSinceMembership: number;
}